import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CloseButton } from '@jsluna/button';
import { List, ListItem } from '@jsluna/list';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NotificationList = function NotificationList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      open = _ref.open,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "open"]);

  return /*#__PURE__*/React.createElement(List, _extends({}, rest, {
    type: "bare",
    className: classnames(className, 'ln-c-activities', {
      'is-open': open
    })
  }), children);
};

NotificationList.displayName = 'NotificationList';
NotificationList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  open: PropTypes.bool
};
NotificationList.defaultProps = {
  className: undefined,
  open: false
};

var NotificationItem = function NotificationItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      notification = _ref.notification,
      handleClose = _ref.handleClose,
      open = _ref.open,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "notification", "handleClose", "open"]);

  return /*#__PURE__*/React.createElement(ListItem, _extends({}, rest, {
    type: "bare",
    className: classnames(className, 'ln-c-activities__item', {
      'ln-c-activities__item--notification': notification,
      'is-open': notification && open
    })
  }), notification && handleClose && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleClose
  }), children);
};

NotificationItem.displayName = 'NotificationItem';
NotificationItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  notification: PropTypes.bool,
  open: PropTypes.bool,
  handleClose: PropTypes.func
};
NotificationItem.defaultProps = {
  className: undefined,
  notification: false,
  open: false,
  handleClose: undefined
};
export { NotificationList, NotificationItem };